import React from "react";

import { PromotionPage } from "page";

function App() {
	return <PromotionPage />;
}

export default App;
